import { AlertTriangle, Activity } from 'lucide-react';
import { Text } from 'components/Elements';

export const SystemHealth = ({ systemMetrics }) => {
  return (
    <div className="p-6 rounded-3xl backdrop-blur-xl bg-white/10 border border-white/20 shadow-lg">
      <Text variant="body" className="text-white font-semibold mb-4">
        System Health (Live)
      </Text>
      <ul className="space-y-3">
        {systemMetrics.map((metric, idx) => (
          <li
            key={idx}
            className="flex justify-between items-center text-sm text-white/70 bg-white/5 p-3 rounded-lg"
          >
            <span className="flex items-center gap-2">
              {metric.status === 'alert' ? (
                <AlertTriangle className="text-red-400" />
              ) : (
                <Activity />
              )}
              {metric.metric}
            </span>
            <span
              className={`${
                metric.status === 'alert'
                  ? 'text-red-400'
                  : metric.status === 'high'
                  ? 'text-yellow-300'
                  : 'text-green-400'
              } font-semibold`}
            >
              {metric.value}
            </span>
          </li>
        ))}
      </ul>
    </div>
  );
};
